import { fetchDoc as fetchDocBase } from "@resto-guru/common-js";

import firebase from "datastore/database";

const fetchDoc = (path) => fetchDocBase(firebase, path);
export default fetchDoc;
